import { useEffect } from 'react';
import { useNavbar } from '@app/atoms/app/navbar.atom.ts';
import { Icon } from '@iconify/react';
import { Button } from '@heroui/react';
import { useNavigate } from 'react-router-dom';

export const CheckoutFailurePage = () => {
  const set = useNavbar();
  const navigate = useNavigate();

  useEffect(() => {
    set.none();
  }, []);
  return (
    <div className="flex flex-col items-center h-[calc(100vh-74px)] justify-center lg:max-w-[680px] lg:mx-auto">
      <Icon
        icon="solar:bill-cross-linear"
        className="w-16 h-16 lg:w-24 lg:h-24 text-[#F53639]"
      />

      <p className="text-lg  lg:text-2xl font-semibold text-[#222222] mt-9">
        Ошибка оплаты
      </p>

      <p className="text-sm lg:text-base text-[#60656C] mt-3 text-center px-4">
        Произошла ошибка при оплате. Попробуйте ещё раз или выберите другой
        способ.
      </p>

      <div className="flex flex-col w-full mt-9 gap-y-4 lg:flex-row gap-x-4">
        <Button
          size="lg"
          fullWidth
          color="primary"
          onPress={() => navigate(`/cart/checkout`)}
        >
          Повторить
        </Button>

        <Button
          size="lg"
          variant="bordered"
          fullWidth
          color="primary"
          onPress={() => navigate('/')}
        >
          Вернуться назад
        </Button>
      </div>
    </div>
  );
};
